import { Settings, PanelType } from "../../Settings";
import { IPanelFactory, PanelParams } from "./IPanelFactory";
import { Panel } from "./panel";
import { PanelOnline } from "./panelOnline";
import { PanelPyramid } from "./panelPyramid";
import { PanelOnlineMoney } from "./panelOnlineMoney";
import { VirtualBotonera } from "./VirtualBotonera";
import { PanelOnlineMultigame } from "./panelOnlineMultigame";
import { PanelOnlineResponsive } from "./panelOnlineResponsive";
import { PanelOnlineResponsive5buttons } from "./panelOnlineResponsive5btns";
import { DefaultTransparentPanel } from "./DefaultTransparentPanel";
import { DefaultBluePanel } from "./DefaultBluePanel";
import { BluePanelSingleGame } from "./bluePanelSingleGame";
import { panelOnlineResponsive5btns1Line as PanelOnlineResponsive5btns1Line } from "./panelOnlineResponsive5btns1line";

// type CreatePanelFunc = (params: PanelParams) => Panel;
type PanelFactoryFunc = (params: PanelParams) => Panel;
// type PanelMap = Readonly<Record<PanelType, CreatePanelFunc>>;

// const panelMap: PanelMap = {
const PanelFactoryMap: Record<PanelType, PanelFactoryFunc> = {
    [PanelType.Ortiz]: (params) => new Panel(params),
    [PanelType.Pyramid]: (params) => new PanelPyramid(params),
    [PanelType.Online]: (params) => new PanelOnline(params),
    [PanelType.OnlineResponsive]: (params) => new PanelOnlineResponsive(params),
    // [PanelType.Online2]: (params) => new PanelOnline2(params),
    [PanelType.OnlineMoney]: (params) => new PanelOnlineMoney(params),
    [PanelType.OnlineGamesMenu]: (params) => new PanelOnlineMultigame(params),
    [PanelType.OnlineResponsive5buttons]: (params) => new PanelOnlineResponsive5buttons(params),
    [PanelType.DefaultGameColorPanel]:  (params) => new Panel(params),
    [PanelType.DefaultBluePanel]:  (params) => new DefaultBluePanel(params),
    [PanelType.DefaultTransparentPanel]:  (params) => new DefaultTransparentPanel(params),
    [PanelType.OnlineJubilee]:  (params) => {throw new Error("Panel OnlineJubilee not implemented");}, 
    [PanelType.BluePanelSingleGame]:  (params) => new BluePanelSingleGame(params),  
    [PanelType.OnlineResponsive5buttons1Line]:  (params) => new PanelOnlineResponsive5btns1Line(params),

};

export class PanelFactory implements IPanelFactory {
    public CreateNewPanel(params: PanelParams): Panel {
        const factoryFunction = PanelFactoryMap[Settings.PanelType];
        return factoryFunction(params);
    }

    public CreateNewPanel1_Screen(params: PanelParams):Panel
    {
        if(Settings.PanelType == PanelType.Online){
            return new PanelOnline(params);
        }
        else if (Settings.PanelType == PanelType.OnlineMoney) {
            return new PanelOnlineMoney(params);
        }
        // else if (Settings.PanelType == PanelType.Online2) {
        //     return new PanelOnline2(params);
        // }
        else if ( Settings.PanelType == PanelType.OnlineGamesMenu ){
            return new PanelOnlineMultigame(params);
        } 
        return new PanelPyramid(params);
    }
}


export class PanelFactoryMiniTouch extends PanelFactory
{
    public CreateNewPanelMiniTouch(params: PanelParams): VirtualBotonera
    {
        return new VirtualBotonera(params);
    }
}

